import { ContactSlugEnum } from '@systemeio/ui'
import { ContactSearchFieldEnum } from '../../enums/contact-enum'
import { ContactFilterType } from '../../types/contact-filter-interface'
import { getDefaultFilterValue } from '../../utils/get-default-filter-value'

export const defaultFilters: ContactFilterType = {
  [ContactSlugEnum.Email]: getDefaultFilterValue(ContactSlugEnum.Email),
  [ContactSearchFieldEnum.removed_at]: getDefaultFilterValue(ContactSearchFieldEnum.removed_at),
  [ContactSearchFieldEnum.removed_reason_type]: getDefaultFilterValue(
    ContactSearchFieldEnum.removed_reason_type,
  ),
}
